import { Redirect, Route, RouteProps } from 'react-router-dom';
import React from 'react';
import { ROUTE } from '../constants/routes';

interface AuthorizeParms extends RouteProps {
  isEnabled: boolean,
  redirect?: string
}

export const AuthorizedRoute = ({isEnabled, redirect = ROUTE.Home, children, ...rest}: AuthorizeParms): JSX.Element => (
  <Route {...rest}>
    {isEnabled ? children : <Redirect to={redirect} />}
  </Route>
);
